<template lang="html">
  <div id="availability" class="contained-height">
    <div class="units-legend
    col-lg-12 col-md-12 col-12"
    :class="{'visible': showUnits || keyplanActive }">
      <div class="d-flex align-items-center justify-content-center h-100"
        v-if="displayMode !== 'keyplan' && deviceMd"
      >
        <span class="mr-2">Available units:</span>
        <span class="mr-2">
          <i class="colour-filtered fas fa-circle"></i>
          <span v-show="showFavourites">favourites</span>
          <span v-show="isFiltered && !showFavourites">filtered</span>
          <span v-show="!isFiltered && !showFavourites">all</span>
        </span>
        <span class="mr-2" v-if="$route.name === 'FloorplanDetail'">
          <i class="colour-floorplan fas fa-circle"></i>
          {{ fpName }}
        </span>
        <span v-if="selectedUnitName">
          <i class="colour-unit fas fa-circle"></i>
          {{ selectedUnitName }}
        </span>
      </div>
    </div>
    <div id="availability-content" class="position-relative">
      <transition name="fade">
        <availability-keyplans v-show="keyplanActive" :active="keyplanActive"
        class="position-absolute availability-keyplans" />
      </transition>
      <availability-scale-model v-if="hasScaleModel && deviceMd" :showUnits="showUnits" />
      <div v-show="keyplanActive" class="north-arrow">
        <img class="ml-4 py-2" src="/static/north-icon.png" />
      </div>
    </div>
    <action-bar class="d-none d-md-block availability-action-bar">
      <template slot="left">
        <div class="availability-toggle" v-if="hasScaleModel">
          <button class="btn btn-action px-2 px-xl-4 py-2 mr-2 mr-xl-3 ml-1 ml-xl-4"
          :class="{
            /* 'btn-link-text': displayMode === 'keyplan', */
            /* 'btn-link-action': displayMode === 'model' */
            'btn-link-action': displayMode === 'keyplan'
          }"
          @click="setDisplayMode('model')">
            3D Model
          </button>
          <button class="btn btn-action px-2 px-xl-4 py-2 mr-1 mr-xl-3 ml-1 ml-xl-4"
          v-show="$route.name === 'FloorplanDetail'"
          :class="{
            /* 'btn-link-text': displayMode === 'model', */
            /* 'btn-link-action': displayMode === 'keyplan' */
            'btn-link-action': displayMode === 'model',
          }"
          @click="setDisplayMode('keyplan')">
            Keyplan
          </button>
        </div>
        <div v-else />
      </template>
      <template slot="right">
        <div class="availability-units-info">
          <span v-show="keyplanActive || !deviceLg">
            {{ availabilityText }}
          </span>
          <span v-show="scaleModelActive && deviceLg" class="mr-2">
            {{ availabilityText }}
          </span>
          <span v-show="scaleModelActive && deviceLg"
          class="show-units"
          @click="showUnits = !showUnits">
            <i v-if="showUnits" class="far fa-check-square"></i>
            <i v-else class="far fa-square"></i>
            show
          </span>
        </div>
      </template>
    </action-bar>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import ActionBar from '@/components/ActionBar';
import AvailabilityScaleModel from './AvailabilityScaleModel';
import AvailabilityKeyplans from './AvailabilityKeyplans';

export default {
  data() {
    return {
      showUnits: true
    };
  },
  computed: {
    ...mapState({
      hasScaleModel: state => state.project.hasScaleModel,
      displayMode: state => state.floorplans.availability.displayMode,
      showFavourites: state => state.floorplans.showFavourites,
      selectedUnitName: state => state.floorplans.selectedUnitName
    }),
    ...mapGetters({
      filteredUnitList: 'floorplans/filteredUnitList',
      floorplanAvailableUnitList: 'floorplans/floorplanAvailableUnitList',
      isFiltered: 'floorplans/isFiltered',
      getFloorplanById: 'floorplans/getFloorplanById',
      deviceMd: 'ui/deviceMd',
      deviceLg: 'ui/deviceLg'
    }),
    availabilityText() {
      let availableUnitsCount = 0;
      if (this.$route.name === 'FloorplanList') {
        availableUnitsCount = this.filteredUnitList.length;
      } else if (this.$route.name === 'FloorplanFavourites') {
        availableUnitsCount = this.filteredUnitList.length;
      } else {
        availableUnitsCount = this.floorplanAvailableUnitList(this.$route.params.id).length;
      }
      if (availableUnitsCount > 1) return `${availableUnitsCount} units available`;
      return `${availableUnitsCount} unit available`;
    },
    scaleModelActive() {
      return this.displayMode === 'model' && this.hasScaleModel && this.deviceMd;
    },
    keyplanActive() {
      return this.displayMode === 'keyplan' || !this.hasScaleModel || !this.deviceMd;
    },
    fpName() {
      try {
        return this.getFloorplanById(this.$route.params.id).current.name;
      } catch (e) {
        console.log(e);
        return '';
      }
    }
  },
  methods: {
    ...mapMutations({
      setDisplayMode: 'floorplans/availability/setDisplayMode'
    })
  },
  watch: {
    $route() {
      if (this.$route.name !== 'FloorplanDetail') {
        this.setDisplayMode('model');
      }
    }
  },
  components: {
    'action-bar': ActionBar,
    'availability-scale-model': AvailabilityScaleModel,
    'availability-keyplans': AvailabilityKeyplans
  }
};
</script>

<style lang="scss" scoped>
#availability {
  background: var(--background);
  overflow: hidden;
}

.availability-keyplans {
  background-color: var(--background);
}

.availability-toggle {
  margin-left: -12px;

  .btn {

  }
}


@media screen and (max-width: $breakpoint-sm) {
  .availability-toggle {
    margin-left: -12px;

    .btn {
      font-size: 1rem;
    }
  }
}

.show-units {
  padding: 10px 0;
  cursor: pointer;
  color: var(--text);

  &:hover {
    color: var(--action);
  }
}

.colour-filtered {
  color: var(--availability-filtered);
}

.colour-floorplan {
  color: var(--availability-floorplan);
}

.colour-unit {
  color: var(--availability-unit);
}

#availability-content {
  height: calc(100% - #{$app-bar-height} - #{$action-bar-height} + 20px);
  @media screen and (max-width: $breakpoint-medium) {
    padding-top: $app-bar-height;
  }
}

.units-legend {
  visibility: hidden;
  background: var(--background);
  position: static;
  top: 0;
  z-index: 500;
  height: $bottom-bar-height;

  @media screen and (max-width: $breakpoint-medium) {
    bottom: auto;
    top: $app-bar-height;
  }
}

.north-arrow {
  position: fixed;
  // bottom: 10px;
  bottom: 10px;
  margin-bottom: calc(#{$app-bar-height} + #{$action-bar-height});

  @media screen and (min-width: $breakpoint-medium) {
    // bottom: $bottom-bar-height;
    bottom: 10px;
  }

  > img {
    width: 40px;
  }
}

.availability-units-info {
  font-style: italic;
}

.availability-action-bar {
  -webkit-box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.15);
  -moz-box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.15);
  box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.15);
  bottom: 1px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/Availability/Availability.vue